import React from 'react'
import ZoomErrorModal from "./ZoomErrorModal";
import DeliveryAreaModal from "./DeliveryAreaModal";
import PickupStoresModal from "./PickupStoresModal";
import DeliveryStoreListModal from "./DeliveryStoreList";
import AddressErrorModalPopup from "./AddressErrorModalPopup";

const StoreAndLocationModals = ({
  updateTemporaryLocation = () => {},
}) => {
  return (
    <>
        <DeliveryAreaModal />
        <DeliveryStoreListModal updateTemporaryLocation={updateTemporaryLocation} />
        <AddressErrorModalPopup />
        <PickupStoresModal />
        <ZoomErrorModal />
    </>
  )
}

export default StoreAndLocationModals